/**
 * Created by Ethan on 16/12/23.
 * 根Reducer，把所有的Reducer合并返回
 */

import { combineReducers } from 'redux';

import AppReducer from './AppReducer';
import AccountUserReducer from '../modules/Account/reducers/UserReducer';
import AccountRoleReducer from '../modules/Account/reducers/RoleReducer';

import WMSDictCityReducer from '../modules/Dict/reducers/CityReducer';
import WMSDictCountyReducer from '../modules/Dict/reducers/CountyReducer';
import WMSDictTownReducer from '../modules/Dict/reducers/TownReducer';

import OrgOrganizationReducer from "../modules/ORG/reduers/OrganizationReducer";
import OrgEmployeeReducer from "../modules/ORG/reduers/EmployeeReducer";

import WMSZoneReducer from '../modules/WMS/reducers/ZoneReducer';

import FtpFileTransferReducer from "../modules/FTP/reducers/FileTransferReducer";

import UserReducer from '../modules/Login/reducers/UserReducer';

const RootReducer = combineReducers({
    AppReducer,
    UserReducer,
    AccountUserReducer,
    AccountRoleReducer,

    WMSDictCityReducer,
    WMSDictCountyReducer,
    WMSDictTownReducer,

    OrgOrganizationReducer,
    OrgEmployeeReducer,

    WMSZoneReducer,


    FtpFileTransferReducer,

});

export default RootReducer;